(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:WidgetTalhoesDiasSemVisitaCtrl
   * @description
   * # WidgetTalhoesDiasSemVisitaCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('WidgetTalhoesDiasSemVisitaCtrl', WidgetTalhoesDiasSemVisitaController);

  /**
   * WidgetTalhoesDiasSemVisitaController dependencies
   * @type {Array}
   */
  WidgetTalhoesDiasSemVisitaController.$inject = [
    '$rootScope',
    '$scope',
    'Dashboard'
  ];

  /**
   * WidgetTalhoesDiasSemVisitaController function declaration
   */
  // eslint-disable-next-line max-lines-per-function,
  function WidgetTalhoesDiasSemVisitaController($rootScope, $scope, Dashboard) {
    const vm = this;
    const DAYS_TICK = 7;

    //////////////////////////////////////////
    // Controller data
    vm.loading = true;
    vm.empty = false;
    vm.error = false;
    vm.chartStyle = {
      width: '100%',
      height: 'auto'
    };
    vm.chartCfg = {
      type: 'BarChart',
      data: {
        cols: [
          { id: 'g', label: 'Talhão', type: 'string' },
          { id: 'd', label: 'Dias', type: 'number' },
          { p: { role: 'annotation' }, role: 'annotation', type: 'string' }
        ],
        rows: []
      },
      options: {
        title: $scope.widget.dataModelOptions.propriedade ?
          $scope.widget.dataModelOptions.propriedade.descricao :
          $rootScope.currentPropriedade.descricao,
        legend: { position: 'none' },
        hAxis: {
          ticks: [0]
        },
        vAxis: {
          textStyle: {
            fontSize: 10
          }
        },
        colors: ['#01365c'],
        height: vm.chartStyle.height,
        width: 'auto',
        annotations: {
          alwaysOutside: true
        },
        chartArea: {
          height: '76%',
          width: '100%',
          left: '30%',
          right: '10%'
        }
      }
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.refresh = Refresh;
    vm.calcChartWidth = CalcChartWidth;

    //////////////////////////////////////////
    // Function declarations
    // eslint-disable-next-line max-lines-per-function,
    function Refresh() {
      vm.chartCfg.data.rows.length = 0;
      vm.chartCfg.options.hAxis.ticks.length = 0;
      vm.chartCfg.options.hAxis.ticks = [0];
      const propriedade = $scope.widget.dataModelOptions.propriedade || $rootScope.currentPropriedade;
      if (propriedade && propriedade.id) {
        vm.loading = true;
        vm.empty = false;
        vm.error = false;

        vm.chartStyle.height = `${propriedade.glebas.length / 1.3 * 40 }px`;
        vm.chartCfg.options.height = vm.chartStyle.height;
        vm.chartCfg.options.width = `${vm.calcChartWidth() }px`;
        vm.chartCfg.options.title = propriedade.descricao;

        Dashboard.glebasVisitadas(propriedade.id).then(function(result) {
          const data = result.data;
          let max = 0;

          vm.chartCfg.data.rows = data.map(function(dado) {
            if (dado.dias_sem_visita > max) {
              max = dado.dias_sem_visita;
            }

            let annotate = 'Nunca visitado';
            if (dado.dias_sem_visita !== null) {
              annotate = dado.dias_sem_visita;
            }

            return {
              c: [
                { v: dado.gleba.descricao },
                { v: dado.dias_sem_visita || 0 },
                { v: annotate }
              ]
            };
          });

          for (let i = 1; i <= Math.ceil(max / DAYS_TICK); i++) {
            vm.chartCfg.options.hAxis.ticks.push(i * DAYS_TICK);
          }
        })
          .catch(function(error) {
            console.error(error);
            vm.error = true;
          })
          .finally(function() {
            vm.loading = false;
          });
      }
    }

    function CalcChartWidth() {
      const width = $scope.widget.size.width;
      const parentWidth = width.substr(0, width.indexOf('px'));
      return parentWidth - 40;
    }

    //////////////////////////////////////////
    // Controller logic

    $rootScope.initialize.then(function() {
      $scope.widget.data = {};

      $scope.widget.data.propriedades = $rootScope.propriedades.map(function(propriedade) {
        return {
          id: propriedade.id,
          glebas: propriedade.glebas,
          descricao: propriedade.descricao
        };
      });

      $scope.$watch('widget.dataModelOptions', function() {
        vm.refresh();
      }, true);
      $scope.$watch('widget.size.width', function() {
        vm.chartCfg.options.width = `${vm.calcChartWidth() }px`;
      });
    }, $rootScope.errorRootInitialize);
  }
}());
